import type { IError } from '../types/error.types';

export class PushNotificationsError extends Error {
  constructor(error: IError) {
    super(error.message);

    this.name = this.constructor.name;
    this.message = error.message;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, () => this.constructor);
    } else {
      this.stack = new Error().stack;
    }
  }
}

export default PushNotificationsError;
